<div
  [class.active]="isActive"
  (click)="isActive = false"
  class="bg">
</div>
<div
  [class.active]="isActive"
  (click)="isActive = !isActive"
  class="lang-select">

  <img
    src="assets/img/lang-icon.svg"
    alt="Lang icon"
    class="lang-select__icon">
  <p
    class="lang-select__current">
    {{currentLang | translate}}
  </p>
  <ul class="lang-select__list">
    <li
      (click)="changeLang('ru')"
      class="lang-select__list-item">
      {{'LANG.RU' | translate}}
    </li>
    <li
      (click)="changeLang('kk')"
      class="lang-select__list-item">
      {{'LANG.KK' | translate}}
    </li>
  </ul>
</div>
